module.exports = __webpack_public_path__ + "img/homePage.3766a3c8.png";